<template>
    <base-layout suite="worksends" :menu-links="mainMenuLinks" :bottom-menu-links="bottomMenuLinks"/>
</template>

<script>
import BaseLayout from './base';

export default {
    components: {BaseLayout},
    data() {
        return {
            mainMenuLinks: {
                dashboard: {title: 'Dashboard'},
                orders: {
                    title: 'Bookblock Orders',
                    requires: ['oms'],
                    submenu: {
                        orders: {title: 'Order Tracking & History'},
                        'orders/enquiries': {title: 'Your Enquiries'},
                    }
                },
                campaigns: {
                    title: 'Marketing Campaigns',
                    submenu: {
                        campaigns: {title: 'Your Campaigns'},
                        'campaigns/action-pages': {title: 'Campaign Action Pages'},
                        'campaigns/corporate-products': {title: 'Corporate Products'},
                        'campaigns/corporate-products/requests': {title: 'Product Requests'},
                    },
                },
                marketplace: {
                    title: 'Marketplace',
                    submenu: {
                        marketplace: {title: 'Physical Gifts'},
                        // 'marketplace/digital': {title: 'eGifts'},
                        'marketplace/orders': {title: 'Order History'},
                    },
                },
                surveys: {
                    title: 'Surveys',
                    tag: 'beta',
                    permission: 'admin',
                    submenu: {
                        surveys: {title: 'Your Surveys'},
                        'surveys/templates': {title: 'Survey Templates'},
                        'surveys/themes': {title: 'Your Survey Themes'},
                        'surveys/themes/gallery': {title: 'Survey Theme Gallery'},
                    }
                },
                fulfilment: {
                    title: 'Fulfilment',
                    tag: 'beta',
                    teams: ['stone','ADHD', 'jeem-life', 'dev-test', 'oriole'], // slugs of teams with fulfilment enabled
                    submenu: {
                        fulfilment: {title: 'Your Shop Orders'},
                        'fulfilment/inventory': {title: 'Warehouse Inventory'},
                        //'fulfilment/returns': {title: 'Returns'},
                    }
                },
            },
            bottomMenuLinks: {
                billing: {
                    title: 'Billing & Payments',
                    submenu: {
                        billing: {title: 'Billing Overview'},
                        'billing/transaction-history-direct': {
                            title: 'Direct Payment Transactions',
                            permission: 'use-cards',
                            plans: ['pro']
                        },
                        'billing/transaction-history': {
                            title: 'Team Balance Transactions',
                            permission: 'team-finance'
                        },
                        'billing/payment-documents': {
                            title: 'Team Payment Documents',
                            permission: 'team-finance'
                        },
                    },
                },
                settings: {
                    title: 'Preferences',
                    submenu: {
                        settings: {title: 'Your Account'},
                        'settings/team': {title: 'Team Settings', permission: 'edit-team-settings'},
                        'settings/team-members': {title: 'Team Members', permission: 'edit-team-members'},
                        'settings/integrations': {title: 'Integrations', permission: 'admin'},
                        resources: {title: 'Guides & Walkthroughs'},
                    },
                },
            }
        };
    },
};
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

